import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '@ups/xplat/core';
import { IDynamicModel } from '@ups/xplat/dynamic-render';
import { deepClone } from '@ups/xplat/utils';
import { Subject } from 'rxjs';

@Directive()
export abstract class EditModalBaseComponent extends BaseComponent {
  @Input() fields: IDynamicModel[];
  @Input() mutateOriginal = true;
  /**
   * When false, Save only emits saveChanges and the host closes the modal with close(true) once
   * its save succeeds, so a failed save keeps the dialog open with the user's input (Bug 35569).
   */
  @Input() closeOnSave = true;
  @Output() saveChanges = new EventEmitter<object>();

  closed$ = new Subject<boolean>();
  public changedModel: object = {};

  protected _current: object = {};
  @Input() set current(v: object) {
    this._current = v;
    this.changedModel = deepClone(v);
  }
  get current() {
    return this._current;
  }

  constructor() {
    super();
  }

  abstract open();
  close(saved?: boolean) {
    this.closed$.next(saved);
    this.hide();
  }
  abstract hide(saved?: boolean);

  protected cancel() {
    this.close();
  }

  protected save(mutateOriginal = this.mutateOriginal) {
    this.saveChanges.emit(this.changedModel);
    if (mutateOriginal) {
      Object.keys(this.changedModel).forEach((key) => {
        this.current[key] = this.changedModel[key];
      });
    }
    if (this.closeOnSave) {
      this.close(true);
    }
  }
}
